@import "~@uipath/apollo-core/src/scss/base-host.scss";

@keyframes slide-in {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(0%); }
}

@-webkit-keyframes slide-in {
  0% { transform: translateX(-100%); }
  100% { -webkit-transform: translateX(0%); }
}
  
@keyframes slide-out {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}

@-webkit-keyframes slide-out {
  0% { -webkit-transform: translateX(0%); }
  100% { -webkit-transform: translateX(-100%); }
}

.portal-surface-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  z-index: 2000;
  cursor: default;

  &.visibility-transition {
    transition: visibility 0.3s;
  }

  &.opacity-transition {
    opacity: 0;
    transition: opacity 0.2s;
  }

  &.visible {
    visibility: visible;

    &.visibility-transition {
      transition: visibility 0.3s;
    }

    &.background-effect {
      background-color: rgba(0, 0, 0, 0.4);
    }
    
    &.opacity-transition {
      opacity: 1;
      transition: opacity 0.2s;
    }
  }
}

.portal-modal {
  background-color: var(--color-background-raised);
  position: absolute;
  z-index: 2001;

  border-radius: $border-thick-l;
  padding-top: $pad-s;
  padding-bottom: $pad-s;

  box-shadow: $shadow-menu-elevation;

  &.slide-in {
    animation: slide-in 0.3s forwards;
    -webkit-animation: slide-in 0.3s forwards;
  }

  &.slide-out {
      animation: slide-out 0.3s forwards;
      -webkit-animation: slide-out 0.3s forwards;
  }
}

.centered-menu {
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  padding: 0px;
}
